export default __webpack_public_path__ + "static/media/add-file.8951a840.svg";